<template>
  <el-dialog
    title="批量上传"
    custom-class="linkUploadDialog"
    :visible.sync="centerDialogVisible"
    width="520px"
    center
    :before-close="closeExcelDialog"
  >
    <div class="linkUploadDialog__dropzone">
      <el-upload
        drag
        action="/"
        :http-request="uploadExcel"
        :show-file-list="false"
      >
        <i class="el-icon-upload" />
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
      <p class="linkUploadDialog__tip">支持 xls / xlsx / csv，上传后预览前 10 行再提交</p>
    </div>
    <el-dialog
      width="90%"
      title="Excel 数据预览"
      custom-class="linkUploadDialog"
      :visible.sync="innerVisible"
      append-to-body
      top="10vh"
    >
      <div class="linkUploadDialog__mode">
        <span class="linkUploadDialog__modeLabel">导入模式</span>
        <el-radio-group v-model="radio" size="small">
          <el-radio label="2">覆盖</el-radio>
          <el-radio label="1">搜索</el-radio>
        </el-radio-group>
      </div>
      <el-table
        class="linkTable linkTable--hybrid"
        :data="excelData.results"
        highlight-current-row
        style="width: 100%"
        max-height="335"
      >
        <el-table-column
          v-for="item of excelData.header"
          :key="item"
          :prop="item"
          :label="item"
          :width="isSearch ? '' : 180"
          header-align="center"
          align="center"
        />
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="innerVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submitExcel">提 交</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import * as XLSX from 'xlsx'

export default {
  props: {
    onSuccess: Function, // eslint-disable-line
    centerDialogVisible: Boolean
  },
  data() {
    return {
      innerVisible: false,
      loading: false,
      radio: '2',
      file: null,
      excelData: {
        header: null,
        results: null
      }
    }
  },
  computed: {
    isSearch: function () {
      let header = this.excelData.header
      return header.length == 1
      //return header.length == 1 && header[0] == 'key'
    }
  },
  methods: {
    closeExcelDialog() {
      this.$emit('update:centerDialogVisible', false)
    },
    submitExcel() {
      // 查找
      if (this.radio == '1') {
        this.onSuccess && this.onSuccess(this.excelData, this.radio, this.file)
        this.innerVisible = false
        this.$emit('update:centerDialogVisible', false)
      } else {
        this.$confirm(`是否确定覆盖`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            // 覆盖-发请求-返回结果之后再发下面的指令
            this.onSuccess &&
              this.onSuccess(this.excelData, this.radio, this.file)
            this.innerVisible = false
            this.$emit('update:centerDialogVisible', false)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消修改'
            })
          })
      }
    },
    uploadExcel(params) {
      let rawFile = params.file
      this.file = rawFile
      let flag = /\.(xlsx|xls|csv)$/.test(rawFile.name)
      if (flag) {
        this.readerData(rawFile)
      } else {
        this.$message({
          type: 'info',
          message: '请按照规定格式上传文件～'
        })
      }
    },
    generateData({ header, results }) {
      this.excelData.header = header
      this.excelData.results = results
      this.innerVisible = true
    },
    readerData(rawFile) {
      this.loading = true
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = (e) => {
          const data = e.target.result
          const workbook = XLSX.read(data, { type: 'array' })
          const firstSheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[firstSheetName]
          const header = this.getHeaderRow(worksheet)
          const results = XLSX.utils.sheet_to_json(worksheet).slice(0, 10)
          this.generateData({ header, results })
          this.loading = false
          resolve()
        }
        reader.readAsArrayBuffer(rawFile)
      })
    },
    getHeaderRow(sheet) {
      const headers = []
      const range = XLSX.utils.decode_range(sheet['!ref'])
      let C
      const R = range.s.r
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) {
        /* walk every column in the range */
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]
        /* find the cell in the first row */
        // let hdr = 'UNKNOWN ' + C // <-- replace with your desired default
        if (cell && cell.t) {
          let hdr = XLSX.utils.format_cell(cell)
          headers.push(hdr)
        }
      }
      return headers
    }
  }
}
</script>
